<template>
  <div class="card challenge">
    <router-link :to="'idea-challenges/idea-challenge/' + ideaChallenge.slug" :title="'View ' + ideaChallenge.title.rendered">
      <img class="card-img-top" :src="ideaChallenge._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url" :title="ideaChallenge.title.rendered" :alt="ideaChallenge.title.rendered">
      <div class="card-body">
        <h6 class="card-title text-center">{{ideaChallenge.title.rendered}}</h6>
        <ul class="fa-ul">
          <li><span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm" style="color: gray"></i></span> {{ideaChallenge.idea_challenge_meta[0][0][0].challenge_date_range}}</li>
          <li><span class="fa-li"><i class="fas fa-trophy fa-fw fa-sm" style="color: goldenrod"></i></span> {{ideaChallenge.idea_challenge_meta[0][0][0].first_prize}}</li>
          <li><span class="fa-li"><i class="fas fa-trophy fa-fw fa-sm" style="color: grey"></i></span> {{ideaChallenge.idea_challenge_meta[0][0][0].second_prize}}</li>
          <li><span class="fa-li"><i class="fas fa-trophy fa-fw fa-sm" style="color: saddlebrown"></i></span> {{ideaChallenge.idea_challenge_meta[0][0][0].third_prize}}</li>
        </ul>
        <p v-if="!excerpt"><strong v-html="ideaChallenge.title.rendered"></strong></p>
        <div v-if="!excerpt" v-html="ideaChallenge.excerpt.rendered"></div>
      </div>
    </router-link>
  </div>
</template>

<script>

export default {
  props: [
    'ideaChallenge',
    'excerpt'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/IdeaChallengeSnippet.vue